import { render, staticRenderFns } from "./ApplicantsValiev.vue?vue&type=template&id=abc1d72a&"
import script from "./ApplicantsValiev.vue?vue&type=script&lang=js&"
export * from "./ApplicantsValiev.vue?vue&type=script&lang=js&"
import style0 from "./ApplicantsValiev.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports